import { render, staticRenderFns } from "./Origami.vue?vue&type=template&id=3c267e8e&scoped=true&"
import script from "./Origami.vue?vue&type=script&lang=js&"
export * from "./Origami.vue?vue&type=script&lang=js&"
import style0 from "./Origami.vue?vue&type=style&index=0&id=3c267e8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c267e8e",
  null
  
)

export default component.exports